"use client";
import React, { createContext, useState, useContext, useEffect } from 'react';

import { fetchAllBlogPosts } from '@/utilities/fetchAllBlogPosts';

const BlogSearchContext = createContext();

export const BlogSearchProvider = ({ initialPosts, children }) => {
  const [query, setQuery] = useState('');
  const [filters, setFilters] = useState([]);
  const [lastSearch, setLastSearch] = useState('');
  const [first, setFirst] = useState(9);
  const [pageInfo, setPageInfo] = useState({});
  const [searchResults, setSearchResults] = useState(initialPosts);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  const searchBlogPosts = async (query = '') => {
    setLastSearch(query);
    setLoading(true);
    try {
      const posts = await fetchAllBlogPosts();
      setSearchResults(posts);
      setLoading(false);
    } catch (e) {
      setError(e);
      setLoading(false);
    }
  };

  return (
    <BlogSearchContext.Provider
      value={{
        setFirst,
        searchBlogPosts,
        searchResults,
        pageInfo,
        loading,
        error,
        first,
        loading,
        query, 
        setQuery,
        filters, 
        setFilters
      }}
    >
      {children}
    </BlogSearchContext.Provider>
  );
};

export const useBlogSearch = () => useContext(BlogSearchContext);
